import { connect } from 'react-redux';

import { getIsMobile } from 'src/store/view/selectors';
import { getPackageId } from '../../store/selectors/package';

import PackageId from './PackageId';

const mapStateToProps = (state) => ({
  id: getPackageId(state),
  isMobile: getIsMobile(state),
});

export default connect(mapStateToProps)(PackageId);
